import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../../components/BreadСrumbs/BreadСrumbs';
import PracticeDetailCase from './PracticeDetailCase';
import PracticeDetailForumBlock from './PracticeDetailForumBlock';
import PracticeDetailRelatedCases from './PracticeDetailRelatedCases';
import { getPracticeCaseByAlias } from '../../../utils/api/services/contest';
import paths from '../../../paths';
import GlobalPreloader from '../../../components/Preloader/GlobalPreloader';
import Preloader from '../../../components/Preloader/Preloader';

export default class PracticeDetail extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.state = {
      practice: null,
      isLoading: true,
      alias: props.match.params.alias,
    };
  }

  componentWillMount = () => {
    this.fetchPracticeData(this.state.alias);
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.match.params.alias !== this.state.someValue) {
      this.setState({ alias: nextProps.match.params.alias });
      this.fetchPracticeData(nextProps.match.params.alias);
    }
  };

  fetchPracticeData = (alias) => {
    this.setState({ isLoading: true });
    getPracticeCaseByAlias(alias)
      .then((practice) => {
        this.setState({
          practice,
        });
      })
      .catch(e => console.log(e))
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  render() {
    const { practice, isLoading } = this.state;
    if (isLoading || !practice || !practice.alias) {
      return (
        <div className="b-center">
          <Preloader />
        </div>
      );
    }
    return (
      <div className="b-center">
        <BreadCrumbs
          data={[
            { url: paths.advocates.main, text: 'Главная' },
            { url: paths.advocates.practice, text: 'Практика' },
            {
              url: `${paths.advocates.practiceCase}/${practice.alias}`,
              text: practice.title,
            },
          ]}
        />

        <h1 className="title -primary">{practice.title}</h1>

        <PracticeDetailCase practice={practice} />

        <PracticeDetailForumBlock practice={practice} />

        <PracticeDetailRelatedCases practice={practice} />
      </div>
    );
  }
}
